// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('board_menu_email');

// eslint-disable-next-line @trello/no-module-logic
export const BoardMenuEmailTemplate = t.renderable(function ({
  commentsEnabled,
  email,
  listName,
  lists,
  position,
  positionName,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (!commentsEnabled) {
    t.p(() => t.format('requires-comments-enabled'));
    t.p(() => t.format('enabled-by-enabling-comments'));
    return;
  }

  t.label({ for: 'boardEmail' }, () =>
    t.format('your-email-address-for-this-board'),
  );
  t.input('.non-empty.js-autofocus', {
    id: 'boardEmail',
    type: 'text',
    name: 'boardEmail',
    readonly: 'readonly',
    placeholder: t.l('loading-ellipsis'),
    value: email,
    style: 'margin: 4px 0 8px;',
  });

  t.a('.nch-button.js-generate-address', { href: '#' }, () =>
    t.format('generate-a-new-email-address'),
  );
  t.a('.nch-button.js-send-address', { href: '#' }, () =>
    t.format('email-me-this-address'),
  );

  t.hr();

  t.label(() => t.format('your-emailed-cards-appear-in-ellipsis'));

  t.div('.form-grid', function () {
    t.div(
      '.button-link.setting.form-grid-child.form-grid-child-twothirds',
      function () {
        t.span('.label', () => t.format('list'));
        t.span('.value.js-list-value', () => t.text(listName));
        t.label(() => t.format('list'));
        return t.select('.js-select-list', () =>
          (() => {
            const result = [];
            // @ts-expect-error TS(2339): Property 'id' does not exist on type 'unknown'.
            for (const { id, name, selected } of Array.from(lists)) {
              result.push(
                t.optionSelected(selected, { value: id }, () => t.text(name)),
              );
            }
            return result;
          })(),
        );
      },
    );

    return t.div('.button-link.setting.form-grid-child', function () {
      t.span('.label', () => t.format('position'));
      t.span('.value.js-pos-value', () => t.text(positionName));
      t.label(() => t.format('position'));
      return t.select('.js-select-position', function () {
        t.optionSelected(position === 'top', { value: 'top' }, () =>
          t.format('top'),
        );
        return t.optionSelected(
          position === 'bottom',
          { value: 'bottom' },
          () => t.format('bottom'),
        );
      });
    });
  });

  t.hr();

  return t.p('.quiet', () =>
    t.format(
      'tip-dont-share-this-email-address-anyone-who-has-it-can-add-cards-as-you-when-composing-emails-the-card-title-goes-in-the-subject-and-the-card-description-in-the-body-more-email-formatting-tips',
    ),
  );
});
